// Tradução amigável (pt-br) dos erros de envio da Meta (WhatsApp Cloud API).
// Cada entrada tem título curto, explicação e ação sugerida. O texto técnico
// original é sempre preservado em `tecnico` (exibido atrás de "ver detalhe").

// Mapa por CÓDIGO da Meta (mais confiável). Chaves como string.
//
// Regra desta tabela: dizer só o que a Meta de fato disse. Uma explicação que
// chuta a causa é pior do que a genérica — um erro de conta descrito como
// "número inválido" faz a empresa revisar a base inteira à toa. Código novo
// que ainda não estiver aqui cai no genérico, que não afirma causa nenhuma.
const BY_CODE = {
  131047: {
    titulo: 'Fora da janela de 24h',
    explicacao:
      'Este número não falou com você nas últimas 24h — a Meta só aceita texto livre dentro dessa janela.',
    acao: 'Use um modelo aprovado, ou peça para a pessoa mandar uma mensagem antes e teste de novo.',
  },
  131026: {
    titulo: 'Mensagem não pôde ser entregue',
    explicacao:
      'O número pode não ter WhatsApp, estar incorreto, ou o aparelho não conseguiu receber. Também ocorre quando o destinatário não aceita mensagens da sua conta.',
    acao: 'Confira se o número está correto e tem WhatsApp ativo.',
  },
  131049: {
    titulo: 'Entrega bloqueada pela Meta (saúde da conta)',
    explicacao:
      'A Meta limitou esta entrega para preservar a experiência do usuário — geralmente por volume alto de marketing ou queda na qualidade do número.',
    acao: 'Reduza envios em massa e priorize mensagens relevantes; acompanhe a qualidade do número.',
  },
  130497: {
    titulo: 'Conta impedida de enviar para este país',
    explicacao:
      'A Meta bloqueou a entrega porque esta conta do WhatsApp Business está restrita de enviar mensagens para usuários do país deste número. A restrição é da conta — o número do destinatário não tem nada a ver com a recusa.',
    acao: 'No Gerenciador da Meta, complete o perfil e o endereço da conta e da Página vinculada, e conclua a verificação de negócio. Confira também se o país do destinatário é permitido para a categoria da sua conta.',
  },
  130472: {
    titulo: 'Mensagem retida por experimento da Meta',
    explicacao:
      'A Meta não entregou esta mensagem porque o número do destinatário faz parte de um experimento dela. Afeta apenas mensagens de marketing.',
    acao: 'Não há correção no envio. Quando o conteúdo permitir, use um template de utilidade em vez de marketing.',
  },
  131042: {
    titulo: 'Pendência de pagamento na conta da Meta',
    explicacao:
      'A Meta recusou o envio por uma pendência de faturamento da conta. Este registro não identifica uma causa mais específica.',
    acao: 'Consulte as pendências de faturamento no Gerenciador da Meta e siga a orientação do detalhe técnico.',
  },
  131048: {
    titulo: 'Envio bloqueado por qualidade do número',
    explicacao:
      'A Meta bloqueou o envio porque este número vem acumulando bloqueios e denúncias de quem recebe as mensagens.',
    acao: 'Reduza o volume, revise o conteúdo e envie só para quem pediu contato. Acompanhe a qualidade do número no Gerenciador.',
  },
  131050: {
    titulo: 'Destinatário optou por não receber marketing',
    explicacao:
      'Este contato pediu para parar de receber mensagens de marketing da sua conta. Mensagens de marketing não são entregues a ele.',
    acao: 'Fale com esse contato apenas por mensagem de utilidade/serviço, ou quando ele iniciar a conversa.',
  },
  131056: {
    titulo: 'Muitas mensagens para o mesmo contato',
    explicacao: 'A Meta limitou a frequência de mensagens entre este número e este destinatário em um curto período.',
    acao: 'Espere um intervalo antes de tentar de novo para esse contato.',
  },
  131045: {
    titulo: 'Número não registrado corretamente na Meta',
    explicacao: 'O envio falhou por causa do registro do seu número na plataforma do WhatsApp Business — ele não está concluído ou precisa ser refeito.',
    acao: 'Conclua (ou refaça) o registro do número no Gerenciador da Meta.',
  },
  131016: {
    titulo: 'Serviço da Meta indisponível no momento',
    explicacao: 'Falha temporária do lado da Meta — não há nada errado com o envio nem com o destinatário.',
    acao: 'Tente novamente mais tarde.',
  },
  131021: {
    titulo: 'Remetente e destinatário são o mesmo número',
    explicacao: 'A Meta não entrega mensagem de um número para ele mesmo.',
    acao: 'Confira o número de destino enviado pela integração.',
  },
  131000: {
    titulo: 'Falha não detalhada pela Meta',
    explicacao: 'A Meta recusou o envio sem informar o motivo. Costuma ser instabilidade momentânea do lado dela.',
    acao: 'Tente novamente; se repetir no mesmo número, contate o suporte com o detalhe técnico.',
  },
  131008: {
    titulo: 'Parâmetro obrigatório ausente',
    explicacao: 'Faltou um dado obrigatório na requisição enviada à Meta — normalmente uma variável ou botão do template.',
    acao: 'Revise as variáveis e os botões enviados pela integração; veja o detalhe técnico para o campo exato.',
  },
  131052: {
    titulo: 'Falha ao baixar a mídia',
    explicacao: 'A Meta não conseguiu baixar o arquivo informado no envio.',
    acao: 'Confira se o link da mídia está público e acessível.',
  },
  131053: {
    titulo: 'Falha ao enviar a mídia',
    explicacao: 'O arquivo não pôde ser carregado pela Meta — formato não suportado ou erro no upload.',
    acao: 'Confira o formato e o tamanho do arquivo aceitos pelo WhatsApp.',
  },
  132015: {
    titulo: 'Template pausado por qualidade',
    explicacao: 'A Meta pausou este template por causa das reações negativas de quem recebeu (bloqueios e denúncias).',
    acao: 'Aguarde a liberação e revise o conteúdo do template antes de voltar a usá-lo.',
  },
  132016: {
    titulo: 'Template desabilitado pela Meta',
    explicacao: 'Este template foi desabilitado em definitivo por qualidade insuficiente e não pode mais ser enviado.',
    acao: 'Crie um novo template com conteúdo revisado e submeta para aprovação.',
  },
  131031: {
    titulo: 'Conta restrita ou bloqueada',
    explicacao: 'A conta do WhatsApp Business foi restrita pela Meta e não pode enviar mensagens no momento.',
    acao: 'Verifique o status da conta no Gerenciador da Meta e regularize as pendências.',
  },
  368: {
    titulo: 'Conta temporariamente bloqueada (política)',
    explicacao: 'A conta foi bloqueada temporariamente por violação das políticas do WhatsApp.',
    acao: 'Revise as políticas e aguarde a liberação; reincidências aumentam o bloqueio.',
  },
  130429: {
    titulo: 'Limite de envio atingido',
    explicacao: 'Você atingiu o limite de velocidade/quantidade de mensagens permitido pela Meta neste período.',
    acao: 'Aguarde e reduza o ritmo de envio. O limite aumenta conforme a conta amadurece.',
  },
  132000: {
    titulo: 'Quantidade de variáveis não bate com o template',
    explicacao:
      'O número de variáveis enviadas é diferente do que o template aprovado espera ({{1}}, {{2}}…).',
    acao: 'Ajuste o template no seu ERP para enviar exatamente as variáveis que o modelo aprovado usa.',
  },
  132001: {
    titulo: 'Template não encontrado',
    explicacao: 'O template informado não existe, não está aprovado, ou o idioma enviado não confere.',
    acao: 'Confira o nome e o idioma do template no Gerenciador da Meta.',
  },
  132005: {
    titulo: 'Conteúdo difere do template aprovado',
    explicacao: 'O texto enviado não corresponde ao conteúdo que a Meta aprovou para este template.',
    acao: 'Reenvie usando exatamente o conteúdo aprovado do template.',
  },
  132007: {
    titulo: 'Conteúdo viola as políticas',
    explicacao: 'O conteúdo do template foi recusado por violar as políticas do WhatsApp.',
    acao: 'Revise o texto do template e submeta uma nova versão para aprovação.',
  },
  132012: {
    titulo: 'Formato de variável inválido',
    explicacao: 'Algum parâmetro enviado está em formato inválido para o template (ex.: tipo errado).',
    acao: 'Verifique os valores das variáveis enviadas pelo ERP.',
  },
  133010: {
    titulo: 'Número ainda não registrado na Meta',
    explicacao: 'O seu número não está registrado e ativo na plataforma do WhatsApp Business, então nenhuma mensagem sai por ele.',
    acao: 'Conclua o registro do número no Gerenciador da Meta.',
  },
  100: {
    titulo: 'Parâmetro inválido na requisição',
    explicacao: 'Algum dado enviado à Meta está inválido ou faltando.',
    acao: 'Revise o template e as variáveis; veja o detalhe técnico para o campo exato.',
  },
  131009: {
    titulo: 'Valor inválido em um dos campos',
    explicacao: 'A Meta recusou o envio porque um dos valores enviados não é aceito — costuma ser uma variável do template com formato ou tamanho fora do permitido.',
    acao: 'Confira os valores que a integração está enviando; o detalhe técnico aponta o campo.',
  },
  135000: {
    titulo: 'Requisição recusada pela Meta',
    explicacao: 'A Meta recusou o envio por um problema na requisição e não detalhou qual.',
    acao: 'Confira o template e as variáveis enviadas. Se repetir, contate o suporte com o detalhe técnico.',
  },

  // Conexão / autorização: o cliente reconecta sozinho pelo botão "Entrar com
  // Facebook" na tela de conexão. Sem esta faixa traduzida, uma autorização
  // vencida aparecia como código solto e virava chamado.
  190: {
    titulo: 'Autorização da Meta expirou',
    explicacao: 'A permissão que o painel usa para enviar em nome da sua conta venceu. Enquanto ela não for renovada, nenhuma mensagem sai.',
    acao: 'Reconecte a conta pelo botão "Entrar com Facebook" na tela de conexão do painel.',
  },
  0: {
    titulo: 'Falha na autorização da conta',
    explicacao: 'A Meta não aceitou a autorização do painel — ela pode ter sido revogada, expirada ou alterada no Gerenciador.',
    acao: 'Reconecte a conta pelo botão "Entrar com Facebook" na tela de conexão do painel.',
  },
  10: {
    titulo: 'Permissão retirada na Meta',
    explicacao: 'Uma permissão necessária para enviar mensagens não está mais concedida ao painel.',
    acao: 'Reconecte a conta pelo botão "Entrar com Facebook" e aceite todas as permissões pedidas.',
  },
  3: {
    titulo: 'Permissão faltando na conta',
    explicacao: 'A conta não tem uma das permissões necessárias para este envio.',
    acao: 'Reconecte a conta pelo botão "Entrar com Facebook" e aceite todas as permissões pedidas.',
  },
  200: {
    titulo: 'Conexão sem autorização válida',
    explicacao: 'A Meta não recebeu uma autorização válida para esta conta no momento do envio.',
    acao: 'Reconecte a conta pelo botão "Entrar com Facebook" na tela de conexão do painel.',
  },
  33: {
    titulo: 'Número excluído na Meta',
    explicacao: 'O número usado para enviar foi excluído da conta no Gerenciador da Meta e não existe mais para a plataforma.',
    acao: 'Confira o número no Gerenciador da Meta e reconecte-o no painel.',
  },

  // Ritmo: diferente do 130429 (limite do número), estes são limites da conta e
  // do aplicativo — o envio volta sozinho quando o ritmo cai.
  80007: {
    titulo: 'Limite de requisições da conta atingido',
    explicacao: 'A conta ultrapassou o número de chamadas que a Meta aceita neste período.',
    acao: 'Reduza o ritmo dos envios; a fila volta a andar quando o limite se recompõe.',
  },
  4: {
    titulo: 'Limite de requisições atingido',
    explicacao: 'Muitas chamadas foram feitas à Meta em pouco tempo e ela passou a recusar temporariamente.',
    acao: 'Aguarde alguns minutos e reduza o ritmo dos envios.',
  },

  // Registro do número (aparece na conexão, não no disparo do dia a dia).
  133004: {
    titulo: 'Serviço da Meta indisponível',
    explicacao: 'A plataforma da Meta está temporariamente fora do ar — não há nada errado com a sua conta.',
    acao: 'Tente novamente mais tarde.',
  },
  133005: {
    titulo: 'PIN de verificação incorreto',
    explicacao: 'O PIN de verificação em duas etapas informado no registro do número não confere.',
    acao: 'Confirme o PIN cadastrado para o número no Gerenciador da Meta e tente de novo.',
  },
  133006: {
    titulo: 'Número precisa ser verificado antes',
    explicacao: 'A Meta exige a verificação do número antes de registrá-lo para envio.',
    acao: 'Conclua a verificação do número no Gerenciador da Meta e repita o registro.',
  },
  133008: {
    titulo: 'PIN errado vezes demais',
    explicacao: 'A Meta bloqueou temporariamente as tentativas de registro por causa de PINs incorretos seguidos.',
    acao: 'Espere o tempo indicado no detalhe técnico antes de tentar de novo.',
  },
  133016: {
    titulo: 'Tentativas de registro em excesso',
    explicacao: 'A Meta bloqueou temporariamente o registro deste número por excesso de tentativas.',
    acao: 'Aguarde e tente novamente mais tarde.',
  },
}

// Códigos que a tela sabe explicar — exportado para os testes cobrirem todas as
// entradas de uma vez (título, explicação e ação em pt-br, sem jargão).
export const CODIGOS_CONHECIDOS = Object.keys(BY_CODE)

// Casamento por PALAVRA-CHAVE no texto (quando não há código). Ordem importa:
// padrões mais específicos primeiro — em especial a restrição por país, que
// precisa ser reconhecida ANTES do "restricted" genérico de conta bloqueada.
const BY_KEYWORD = [
  { re: /24\s*hours|re-?engagement|last replied/i, code: 131047 },
  { re: /restricted from messaging|users in (this|certain) countr/i, code: 130497 },
  { re: /template name .*does not exist|does not exist in|template.*not.*found/i, code: 132001 },
  { re: /number of (localizable_)?params|parameter count|expected \d+ param/i, code: 132000 },
  { re: /template.*paused/i, code: 132015 },
  { re: /template.*disabled/i, code: 132016 },
  { re: /stop receiving marketing|opted out of marketing/i, code: 131050 },
  { re: /part of an experiment/i, code: 130472 },
  { re: /incomplete\s+tax\s+information|payment|billing|credit line/i, code: 131042 },
  { re: /rate limit|too many|throughput/i, code: 130429 },
  { re: /restricted|account.*locked|disabled/i, code: 131031 },
  { re: /undeliverable|not.*registered on whatsapp|invalid.*recipient/i, code: 131026 },
  { re: /invalid parameter/i, code: 100 },
]

// Texto que os webhooks de status gravavam em TODA falha, como se fosse o
// motivo da Meta. Não é: é uma frase nossa que afirma coisas sobre o número do
// destinatário sem nenhuma base no que a Meta respondeu. Não pode aparecer como
// "detalhe técnico" nem servir de pista pro casamento por palavra-chave —
// nesses registros o motivo real simplesmente não foi guardado.
const TEXTO_LEGADO_SEM_MOTIVO = /a mensagem foi processada, por[ée]m n[ãa]o p[ôo]de ser entregue/i

function normalizeCode(code) {
  if (code == null) return null
  const n = String(code).trim()
  return n || null
}

// O mesmo código cobre pendências diferentes. Só especificamos a causa quando
// o detalhe a informa; mencionar pagamento no título padrão não prova falha no cartão.
function detalharFaturamento(text) {
  if (/incomplete\s+tax\s+information/i.test(text)) {
    return {
      titulo: 'Informações fiscais incompletas na conta da Meta',
      explicacao: 'A Meta informou que faltam informações fiscais da conta e recusou o envio por essa pendência.',
      acao: 'Complete as informações fiscais na área de faturamento do Gerenciador da Meta. Se houver um link no detalhe, use-o para acessar a pendência.',
    }
  }
  if (/errors?\s+related\s+to\s+(?:your\s+)?payment\s+method/i.test(text)) {
    return {
      titulo: 'Método de pagamento com erro na conta da Meta',
      explicacao: 'A Meta informou um erro relacionado ao método de pagamento da conta e recusou o envio.',
      acao: 'Revise o método de pagamento na área de faturamento do Gerenciador da Meta e siga a orientação apresentada para corrigir o erro.',
    }
  }
  return BY_CODE[131042]
}

// Detalhes externos são texto, nunca HTML. Aceitamos apenas URLs absolutas
// HTTP(S), sem credenciais ou barras invertidas que possam disfarçar o destino.
export function extractMetaErrorLinks(text) {
  if (typeof text !== 'string') return []
  const links = new Set()
  const candidates = text.matchAll(/https?:\/\/[^\s<>"'`]+/gi)
  for (const match of candidates) {
    if (match.index > 0 && /[\w:+/\\]/.test(text[match.index - 1])) continue
    const candidate = match[0].replace(/[.,;:!?)}\]]+$/, '')
    if (candidate.includes('\\') || !/^https?:\/\/[^/]/i.test(candidate)) continue
    try {
      const url = new URL(candidate)
      if (!['http:', 'https:'].includes(url.protocol) || !url.hostname || url.username || url.password) continue
      links.add(url.href)
    } catch {
      // URL malformada continua disponível apenas no texto técnico original.
    }
  }
  return [...links]
}

export function translateMetaError(erro) {
  if (!erro) return null
  // O DETALHE da Meta vem primeiro: por muito tempo o webhook de status gravou
  // um texto genérico nosso em `text` ("verifique se o número informado está
  // correto...") junto do detalhe verdadeiro em `details`. Nesses registros —
  // que continuam no histórico — mostrar o `text` seria repetir uma causa que
  // nunca foi a real.
  const bruto = erro.details || erro.text || erro.title || ''
  const ehLegadoSemMotivo = TEXTO_LEGADO_SEM_MOTIVO.test(bruto)
  const text = ehLegadoSemMotivo ? '' : bruto
  const code = normalizeCode(erro.code)

  // Sem nada aproveitável devolvemos null e quem chama mostra o texto cru do
  // banco — MENOS quando o único texto é o legado sem motivo: aí o cru é
  // justamente a frase falsa sobre o número do destinatário, e devolver null
  // faria a tela reimprimi-la. Nesse caso assumimos o genérico honesto.
  if (!text && !code) return ehLegadoSemMotivo ? generico(null, null) : null

  let entry = code ? BY_CODE[code] : null

  if (!entry && text) {
    const hit = BY_KEYWORD.find((k) => k.re.test(text))
    if (hit) entry = BY_CODE[hit.code]
  }

  if (entry) {
    if (entry === BY_CODE[131042]) entry = detalharFaturamento(text)
    return { ...entry, tecnico: text || null, code: code || null }
  }

  return generico(text, code)
}

// Genérico: não reconhecido, mas preserva o técnico pra suporte. A flag
// `generica` permite ao chamador preferir outra mensagem (ex.: a message pt-br
// específica do envelope do master) quando a tradução não reconheceu. Nunca
// arrisca um palpite de causa: sem código no dicionário, o que a tela pode
// afirmar é só que a Meta não entregou.
function generico(text, code) {
  return {
    titulo: 'Falha no envio pela Meta',
    explicacao: text
      ? 'A Meta não entregou esta mensagem. O motivo exato está no detalhe técnico.'
      : 'A Meta não entregou esta mensagem e não informou o motivo neste registro.',
    acao: 'Se persistir, contate o suporte com o código e o detalhe técnico.',
    tecnico: text || null,
    code: code || null,
    generica: true,
  }
}

const metaErrorsLib = { translateMetaError }

export default metaErrorsLib
